/**
 * True only under a local dev server. `craco build` sets NODE_ENV='production', so this is a
 * compile-time constant in any built bundle and guarded branches are dropped by dead-code
 * elimination — use it (not `checkIsDev`, which is also true on deployed non-prod builds) to keep
 * something strictly off every deployed environment.
 */
function useIsLocal(): boolean {
  return process.env.NODE_ENV === 'development';
}

export default useIsLocal;
